import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';
import { Group, rem, Text } from '@mantine/core';

interface Props {
	iconVariant: PredefinedIcons;
	text: string;
}

export const CapChartMapShape = ({ iconVariant, text }: Props) => (
	<Group gap={6} wrap="nowrap" bg="gray.2" px={8} py={4} style={{ borderRadius: rem(16) }}>
		<Icon variant={iconVariant} size={rem(14)} color="var(--mantine-color-dark-8)" />
		<Text fz="sm" lh={rem(16)} c="dark.8" truncate>
			{text}
		</Text>
	</Group>
);
